(function () {
  'use strict';

  // ── Blackfish Giveaway form ───────────────────────────────────────────
  // Clone of winter-giveaway.js with bfg- namespace.
  // Changes from source:
  //   • All wg- selectors → bfg-
  //   • list id: RdjCiQ → RLrSCP
  //   • custom_source: 'Winter Giveaway 2026' → 'Blackfish Giveaway 2026'
  //   • Countdown code removed (no countdown on this page)
  //   • Console prefix changed to [BFG Form]
  // Do not share this file with winter-giveaway.js.

  function initForm() {
    var form = document.getElementById('bfg-entry-form');
    if (!form) return;

    var submitBtn   = form.querySelector('.bfg-form__submit');
    var successEl   = document.getElementById('bfg-success');
    var globalErrEl = form.querySelector('.bfg-form__global-err');

    function normPhone(raw) {
      var s = raw.replace(/[\s\-().]/g, '');
      if (/^0[45]\d{8}$/.test(s)) return '+61' + s.slice(1);
      if (/^\+61[45]\d{8}$/.test(s)) return s;
      return null;
    }

    function setErr(input, msgEl, msg) {
      input.classList.add('bfg-form__input--err');
      if (msgEl) { msgEl.textContent = msg; msgEl.classList.add('bfg-form__err-msg--on'); }
    }
    function clrErr(input, msgEl) {
      input.classList.remove('bfg-form__input--err');
      if (msgEl) msgEl.classList.remove('bfg-form__err-msg--on');
    }

    function validate() {
      var ok = true;

      var fn = form.querySelector('#bfg-fn'), fnE = form.querySelector('#bfg-fn-err');
      clrErr(fn, fnE);
      if (!fn.value.trim()) { setErr(fn, fnE, 'First name is required.'); ok = false; }

      var ln = form.querySelector('#bfg-ln'), lnE = form.querySelector('#bfg-ln-err');
      clrErr(ln, lnE);
      if (!ln.value.trim()) { setErr(ln, lnE, 'Last name is required.'); ok = false; }

      var em = form.querySelector('#bfg-em'), emE = form.querySelector('#bfg-em-err');
      clrErr(em, emE);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) {
        setErr(em, emE, 'Please enter a valid email address.'); ok = false;
      }

      var ph = form.querySelector('#bfg-ph'), phE = form.querySelector('#bfg-ph-err');
      clrErr(ph, phE);
      if (!normPhone(ph.value.trim())) {
        setErr(ph, phE, 'Enter a valid AU mobile (e.g. 0412 345 678).'); ok = false;
      }

      var sms = form.querySelector('#bfg-sms'), smsE = form.querySelector('#bfg-sms-err');
      if (smsE) smsE.classList.remove('bfg-form__err-msg--on');
      if (!sms.checked) {
        if (smsE) { smsE.textContent = 'SMS consent is required to enter.'; smsE.classList.add('bfg-form__err-msg--on'); }
        ok = false;
      }

      var eml = form.querySelector('#bfg-eml'), emlE = form.querySelector('#bfg-eml-err');
      if (emlE) emlE.classList.remove('bfg-form__err-msg--on');
      if (!eml.checked) {
        if (emlE) { emlE.textContent = 'Email consent is required to enter.'; emlE.classList.add('bfg-form__err-msg--on'); }
        ok = false;
      }

      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (globalErrEl) globalErrEl.classList.remove('bfg-form__global-err--on');
      if (!validate()) return;

      submitBtn.disabled = true;
      var orig = submitBtn.textContent;
      submitBtn.textContent = 'Entering\u2026';

      var phone = normPhone(form.querySelector('#bfg-ph').value.trim());

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Blackfish Giveaway 2026',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email:        form.querySelector('#bfg-em').value.trim(),
                  phone_number: phone,
                  first_name:   form.querySelector('#bfg-fn').value.trim(),
                  last_name:    form.querySelector('#bfg-ln').value.trim()
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: 'RLrSCP' } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UinWNa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.status === 202) {
          form.style.display = 'none';
          if (successEl) successEl.classList.add('bfg-form__success--on');
        } else {
          return res.json().then(function (body) {
            var detail = (body.errors && body.errors[0] && body.errors[0].detail) || ('Status ' + res.status);
            throw new Error('[Klaviyo ' + res.status + '] ' + detail);
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = orig;
        if (globalErrEl) {
          globalErrEl.textContent = 'Something went wrong. Please try again.';
          globalErrEl.classList.add('bfg-form__global-err--on');
        }
        console.error('[BFG Form]', err.message || err);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForm);
  } else {
    initForm();
  }
})();
